/* global bootstrap */

import React, { useContext, useState, useEffect } from "react";
import AddRemoveModal from "../../modals/AddRemoveModal";
import ReportModal from "../../modals/ReportModal";
import LanguageContext from "../../utils/Contexts/LanguageContext";
import axiosInstance from "../../utils/Requests/axios";
import toast from "react-hot-toast";
import moment from "moment";
import UserContext from "../../utils/Contexts/UserContext";
import { useNavigate } from "react-router-dom";
import Constant from "../Constants";
import { formatThousand } from "../../utils";

function Table({
  columnsVisibility,
  data,
  listsData,
  activeTab,
  columnSorts,
  setColumnSorts,
  selectedList,
  setData,
}) {
  const { t } = useContext(LanguageContext);
  const { userData } = useContext(UserContext);
  const [selectedItem, setSelectedItem] = useState(null);
  const navigate = useNavigate();
  const { languageOptions, categoryOptions } = Constant();
  const navigateToPlacement = (item) => {
    navigate(`/offers-search/domain/${item?.uuid}`);
  };

  const addToList = (listItemUuid, listItemName, itemUuid) => {
    const url = `/users/${userData?.uuid}/preferences/domains/${itemUuid}/lists`;

    axiosInstance
      .put(url, [listItemUuid])
      .then(() => {
        toast.success(t(`The domain has been added to ${listItemName}`));

        const favoritesUuid = listsData.find(
          (listItem) => listItem.name === "Favorites"
        )?.uuid;

        const blacklistUuid = listsData.find(
          (listItem) => listItem.name === "Blacklist"
        )?.uuid;

        if (
          (activeTab === "All" || activeTab === "Filtered") &&
          listItemUuid === blacklistUuid
        ) {
          setData((prevData) =>
            prevData.filter((item) => item?.uuid !== itemUuid)
          );
        } else if (listItemUuid === blacklistUuid) {
          setData((prevData) =>
            prevData.map((item) =>
              item?.uuid === itemUuid
                ? {
                    ...item,
                    lists: [...item?.lists, listItemUuid],
                  }
                : item
            )
          );
        }

        if (listItemUuid === favoritesUuid) {
          setData((prevData) =>
            prevData.map((item) =>
              item?.uuid === itemUuid
                ? {
                    ...item,
                    lists: [...item?.lists, listItemUuid],
                  }
                : item
            )
          );
        }
      })
      .catch(() => {
        toast.error(t(`There was an error adding domain to ${listItemName}`));
        // Handle error (e.g., show an error message)
      });
  };

  const removeFromList = (listItemUuid, listItemName, itemUuid) => {
    // Construct URL using template literals
    const url = `/users/${userData?.uuid}/preferences/domains/${itemUuid}/lists`;

    axiosInstance
      .delete(url, { data: [listItemUuid] })
      .then(() => {
        toast.success(t(`The domain has been removed from ${listItemName}`));
        const favoritesUuid = listsData.find(
          (listItem) => listItem.name === "Favorites"
        )?.uuid;

        const blacklistUuid = listsData.find(
          (listItem) => listItem.name === "Blacklist"
        )?.uuid;

        if (activeTab === "Blacklist" && listItemUuid === blacklistUuid) {
          setData((prevData) =>
            prevData.filter((item) => item.uuid !== itemUuid)
          );
        } else {
          setData((prevData) =>
            prevData.map((item) =>
              item.uuid === itemUuid
                ? {
                    ...item,
                    lists: item.lists.filter((id) => id !== listItemUuid),
                  }
                : item
            )
          );
        }

        if (activeTab === "Favorites" && listItemUuid === favoritesUuid) {
          setData((prevData) =>
            prevData.filter((item) => item.uuid !== itemUuid)
          );
        } else {
          setData((prevData) =>
            prevData.map((item) =>
              item.uuid === itemUuid
                ? {
                    ...item,
                    lists: item.lists.filter((id) => id !== listItemUuid),
                  }
                : item
            )
          );
        }
        if (
          activeTab !== "Favorites" &&
          activeTab !== "Blacklist" &&
          activeTab !== "All" &&
          activeTab !== "Filtered"
        ) {
          setData((prevData) =>
            prevData.filter((item) => item.uuid !== itemUuid)
          );
        }
      })
      .catch(() => {
        toast.error(
          t(`There was an error removing domain from ${listItemName}`)
        );
        // Handle error (e.g., show an error message)
      });
  };

  const setColumnSort = (columnIndex) => {
    const columnSortData = { ...columnSorts };
    if (!columnSortData[columnIndex]) columnSortData[columnIndex] = "asc";
    else if (columnSortData[columnIndex] === "asc")
      columnSortData[columnIndex] = "desc";
    else if (columnSortData[columnIndex] === "desc")
      columnSortData[columnIndex] = null;
    setColumnSorts(columnSortData);
  };

  let tooltipInit = false;
  useEffect(() => {
    if (!tooltipInit) {
      const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );
      [...tooltipTriggerList].forEach(
        (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
      tooltipInit = true;
    }
  }, [data]);

  const formatNumberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className="table-responsive datatable-custom">
      <table
        id="datatable"
        className="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table"
      >
        <thead className="thead-light">
          <tr>
            <th></th>
            {columnsVisibility.name && (
              <th
                className={`table-column-ps-0 sorting${
                  !columnSorts[1]
                    ? ""
                    : columnSorts[1] === "asc"
                    ? "_asc"
                    : "_desc"
                }`}
                onClick={() => setColumnSort(1)}
              >
                {t("Name")}
              </th>
            )}
            {columnsVisibility.dr && (
              <th
                className={`sorting${
                  !columnSorts[2]
                    ? ""
                    : columnSorts[2] === "asc"
                    ? "_asc"
                    : "_desc"
                }`}
                onClick={() => setColumnSort(2)}
              >
                {t("DR")}
              </th>
            )}
            {columnsVisibility.tat && (
              <th
                className={`sorting${
                  !columnSorts[3]
                    ? ""
                    : columnSorts[3] === "asc"
                    ? "_asc"
                    : "_desc"
                }`}
                onClick={() => setColumnSort(3)}
              >
                {t("TAT")}
              </th>
            )}
            {columnsVisibility.traffic && (
              <th
                className={`sorting${
                  !columnSorts[4]
                    ? ""
                    : columnSorts[4] === "asc"
                    ? "_asc"
                    : "_desc"
                }`}
                onClick={() => setColumnSort(4)}
              >
                {t("Traffic")}
              </th>
            )}
            {columnsVisibility.niches && <th>{t("Niches")}</th>}
            {columnsVisibility.language && <th>{t("Language")}</th>}
            {columnsVisibility.guest_post && (
              <th
                className={`sorting${
                  !columnSorts[7]
                    ? ""
                    : columnSorts[7] === "asc"
                    ? "_asc"
                    : "_desc"
                }`}
                onClick={() => setColumnSort(7)}
              >
                {t("Guest Post")}
              </th>
            )}
            {columnsVisibility.link_insert && (
              <th
                className={`sorting${
                  !columnSorts[8]
                    ? ""
                    : columnSorts[8] === "asc"
                    ? "_asc"
                    : "_desc"
                }`}
                onClick={() => setColumnSort(8)}
              >
                {t("Link Insert")}
              </th>
            )}
            {columnsVisibility.links && (
              <th
                className={`sorting${
                  !columnSorts[9]
                    ? ""
                    : columnSorts[9] === "asc"
                    ? "_asc"
                    : "_desc"
                }`}
                onClick={() => setColumnSort(9)}
              >
                {t("Links")}
              </th>
            )}
            {columnsVisibility.domain_age && <th>{t("Domain Age")}</th>}
          </tr>
        </thead>
        <tbody>
          {!!data?.length ? (
            data?.map((item, index) => (
              <tr key={index}>
                <td className="p-1">
                  <div className="dropdowm">
                    <button
                      type="button"
                      className="btn btn-ghost-secondary btn-icon btn-sm rounded-circle"
                      id={`teamsDropdown${index}`}
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      onClick={() => setSelectedItem(item)}
                    >
                      <i className="bi-three-dots-vertical"></i>
                    </button>

                    <div
                      className="dropdown-menu dropdown-menu-sm dropdown-menu-end"
                      aria-labelledby={`teamsDropdown${index}`}
                    >
                      <button
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#modal-sm-add-remove-to-lists"
                      >
                        <i className="bi-plus-circle-dotted dropdown-item-icon"></i>
                        {t("Add to List ...")}
                      </button>
                      <button
                        className="dropdown-item js-add-to-favorites"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          const listItem = listsData.find(
                            (listItem) => listItem.name === "Favorites"
                          );
                          !item.lists.includes(listItem.uuid)
                            ? addToList(
                                listItem.uuid,
                                listItem.name,
                                item?.uuid
                              )
                            : removeFromList(
                                listItem.uuid,
                                listItem.name,
                                item?.uuid
                              );
                        }}
                      >
                        <i className="bi-star dropdown-item-icon"></i>
                        {!item.lists.includes(
                          listsData.find(
                            (listItem) => listItem.name === "Favorites"
                          )?.uuid
                        )
                          ? t("Add to Favorites")
                          : t("Remove from Favorites")}
                      </button>
                      <button
                        className="dropdown-item js-add-to-blacklist"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          const listItem = listsData.find(
                            (listItem) => listItem.name === "Blacklist"
                          );
                          !selectedList || selectedList.name !== "Blacklist"
                            ? addToList(
                                listItem.uuid,
                                listItem.name,
                                item?.uuid
                              )
                            : removeFromList(
                                listItem.uuid,
                                listItem.name,
                                item?.uuid
                              );
                        }}
                      >
                        <i className="bi-slash-circle dropdown-item-icon"></i>
                        {!selectedList || selectedList.name !== "Blacklist"
                          ? t("Add to Blacklist")
                          : t("Remove from Blacklist")}
                      </button>
                      {selectedList &&
                        selectedList.name !== "Favorites" &&
                        selectedList.name !== "Blacklist" && (
                          <button
                            className="dropdown-item js-remove-from-list"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              removeFromList(
                                selectedList.uuid,
                                selectedList.name,
                                item?.uuid
                              );
                            }}
                          >
                            <i className="bi-x dropdown-item-icon"></i>
                            {t(`Remove from ${selectedList.name}`)}
                          </button>
                        )}
                      <div className="dropdown-divider"></div>
                      <button
                        className="dropdown-item text-danger"
                        data-bs-toggle="modal"
                        data-bs-target="#modalReport"
                      >
                        <i className="bi-flag dropdown-item-icon"></i>{" "}
                        {t("Report")}
                      </button>
                    </div>
                  </div>
                </td>
                {columnsVisibility.name && (
                  <td className="table-column-ps-0">
                    {/* eslint-disable-next-line */}
                    <a href="javascript:;"
                      className="d-flex align-items-center mb-2"
                    >
                      <div className="flex-grow-1">
                        <span className="h5 text-inherit">
                          <span onClick={() => navigateToPlacement(item)}>
                            {item?.domain}
                          </span>
                          {selectedList &&
                            selectedList.name === "Blacklist" && (
                              <i
                                className="bi-slash-circle text-muted ms-1"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Added to Blacklist"
                              />
                            )}{" "}
                          <>
                            <i
                              className="bi-person-check text-muted ms-1"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Verified Owner"
                            />{" "}
                            {item?.lists?.includes(
                              listsData.find(
                                (listItem) => listItem.name === "Favorites"
                              )?.uuid
                            ) && (
                              <i
                                className="bi-star text-muted ms-1"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Added to Favorites"
                              />
                            )}{" "}
                            {item?.lists?.length > 0 && (
                              <i
                                className="bi-card-list text-muted ms-1"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={`Added to ${item?.lists?.length} List(s)`}
                              />
                            )}
                          </>
                        </span>
                      </div>
                    </a>
                    {/* Render summary categories if available */}
                    {item?.summary?.categories?.length ? (
                      <span>
                        {item?.summary?.categories
                          ?.slice(0, 3)
                          ?.map((category, i) => (
                            <span
                              key={i}
                              className="badge bg-soft-secondary text-secondary me-1"
                            >
                              {categoryOptions[category]}
                            </span>
                          ))}
                        {item?.summary?.categories?.length > 3 ? (
                          <span className="badge bg-soft-secondary text-secondary">
                            + {item?.summary?.categories?.length - 3}{" "}
                            {t("more")}
                          </span>
                        ) : (
                          ""
                        )}
                      </span>
                    ) : (
                      <span className="badge bg-soft-secondary text-secondary">
                        Any Category
                      </span>
                    )}
                  </td>
                )}
                {columnsVisibility.dr && <td>{item?.summary?.dr || "-"}</td>}
                {columnsVisibility.tat && (
                  <td>
                    {item?.summary?.tat || (
                      <span className="badge bg-soft-secondary text-secondary">
                        {t("new")}
                      </span>
                    )}
                  </td>
                )}
                {columnsVisibility.traffic && (
                  <td>
                    {item?.summary?.traffic
                      ? formatThousand(item?.summary?.traffic)
                      : "-"}
                  </td>
                )}
                {columnsVisibility.niches && (
                  <td>
                    <div className="col-auto">
                      <div className="avatar-group avatar-group-xs mb-1">
                        {item?.summary?.niches?.length
                          ? item.summary.niches.map((niche, i) => {
                              let avatarClass;
                              let title;
                              let content;

                              if (niche === 1) {
                                avatarClass = "primary";
                                title = t("General");
                                content = (
                                  <i className="bi-file-earmark-richtext"></i>
                                );
                              } else if (niche === 2) {
                                avatarClass = "secondary";
                                title = t("Gambling");
                                content = <i className="bi bi-dice-5"></i>;
                              } else if (niche === 3) {
                                avatarClass = "secondary";
                                title = t("Crypto");
                                content = (
                                  <i className="bi bi-currency-bitcoin"></i>
                                );
                              } else if (niche === 4) {
                                avatarClass = "secondary";
                                title = t("Medications");
                                content = <i className="bi bi-capsule"></i>;
                              } else if (niche === 5) {
                                avatarClass = "secondary";
                                title = t("Dating");
                                content = (
                                  <i className="bi bi-chat-left-heart"></i>
                                );
                              } else if (niche === 6) {
                                avatarClass = "secondary";
                                title = t("Adult");
                                content = (
                                  <span style={{ fontSize: "8px" }}>18+</span>
                                );
                              }

                              return (
                                <span
                                  key={i}
                                  className={`avatar avatar-${avatarClass} avatar-circle`}
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title={title}
                                >
                                  <span className="avatar-initials">
                                    {content}
                                  </span>
                                </span>
                              );
                            })
                          : "-"}
                      </div>
                    </div>
                  </td>
                )}
                {columnsVisibility.language && (
                  <td>
                    {item?.summary?.languages?.length
                      ? item?.summary?.languages?.map((language, i) => (
                          <span key={i}>
                            {languageOptions[language]}
                            {i + 1 !== item?.summary?.languages?.length
                              ? ", "
                              : ""}
                          </span>
                        ))
                      : "-"}
                  </td>
                )}
                {columnsVisibility.guest_post && (
                  <td>
                    {item?.summary?.placements?.find(
                      (placement) => placement.type === 1
                    )
                      ? `$${formatNumberWithCommas(
                          item?.summary?.placements?.find(
                            (placement) => placement.type === 1
                          )?.prices?.min
                        )}
                        ${
                          item?.summary?.placements?.find(
                            (placement) => placement.type === 1
                          )?.prices?.min !==
                          item?.summary?.placements?.find(
                            (placement) => placement.type === 1
                          )?.prices?.max
                            ? `- $${formatNumberWithCommas(
                                item?.summary?.placements?.find(
                                  (placement) => placement.type === 1
                                )?.prices?.max
                              )}`
                            : ""
                        }`
                      : "-"}
                  </td>
                )}
                {columnsVisibility.link_insert && (
                  <td>
                    {item?.summary?.placements?.find(
                      (placement) => placement.type === 2
                    )
                      ? `$${formatNumberWithCommas(
                          item?.summary?.placements?.find(
                            (placement) => placement.type === 2
                          )?.prices?.min
                        )}
                        ${
                          item?.summary?.placements?.find(
                            (placement) => placement.type === 2
                          )?.prices?.min !==
                          item?.summary?.placements?.find(
                            (placement) => placement.type === 2
                          )?.prices?.max
                            ? `- $${formatNumberWithCommas(
                                item?.summary?.placements?.find(
                                  (placement) => placement.type === 2
                                )?.prices?.max
                              )}`
                            : ""
                        }`
                      : "-"}
                  </td>
                )}
                {columnsVisibility.links && (
                  <td>
                    <div className="avatar-group avatar-group-xs mb-1">
                      {item?.summary?.links?.length
                        ? item?.summary?.links?.map((link, index) => (
                            <span
                              key={index}
                              style={{ marginLeft: index > 0 ? "-10px" : 0 }}
                            >
                              {link === 1 && (
                                <span
                                  className="avatar avatar-primary avatar-circle"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  aria-label="Do Follow"
                                  data-bs-original-title="Do Follow"
                                >
                                  <span className="avatar-initials">
                                    <i className="bi-link-45deg"></i>
                                  </span>
                                </span>
                              )}
                              {link === 2 && (
                                <span
                                  className="avatar avatar-secondary avatar-circle"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  aria-label="No Follow"
                                  data-bs-original-title="No Follow"
                                >
                                  <span className="avatar-initials">
                                    <i className="bi-link-45deg"></i>
                                  </span>
                                </span>
                              )}
                              {link === 3 && (
                                <span
                                  className="avatar avatar-secondary avatar-circle"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  aria-label="Sponsored"
                                  data-bs-original-title="Sponsored"
                                >
                                  <span className="avatar-initials">
                                    <i className="bi bi-currency-dollar"></i>
                                  </span>
                                </span>
                              )}
                            </span>
                          ))
                        : "-"}
                    </div>
                  </td>
                )}
                {columnsVisibility.domain_age && (
                  <td>
                    {item?.summary?.created
                      ? moment(item?.summary?.created).fromNow(true)
                      : "-"}
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="100%">
                <div
                  className="text-center p-4"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    textAlign: "center",
                  }}
                >
                  <img
                    className="mb-3"
                    src="https://static.articlesfactory.ai/app/svg/illustrations-light/oc-error.svg"
                    alt=""
                    style={{ width: "10rem" }}
                    data-hs-theme-appearance="dark"
                  />
                  <img
                    className="mb-3"
                    src="https://static.articlesfactory.ai/app/svg/illustrations/oc-error.svg"
                    alt=""
                    style={{ width: "10rem" }}
                    data-hs-theme-appearance="default"
                  />
                  <p className="mb-0">
                    {!data ? t("Loading data") : t("No data to show")}
                  </p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <AddRemoveModal listsData={listsData} listItem={selectedItem} />
      <ReportModal />
    </div>
  );
}

export default Table;
